import styled from 'styled-components';

const Card = styled.div`
  background: ${({ theme }) => theme.colors.surface};
  border: 1px solid ${({ theme }) => theme.colors.border};
  border-radius: ${({ theme }) => theme.radii.sm};
  padding: 1.75rem;
  box-shadow: ${({ theme }) => theme.glow.soft};
  transition: transform 200ms ease, box-shadow 200ms ease, border-color 200ms ease;
`;

export default Card;
